export const createPrependSubscribableThing = (wrapSubscribeFunction) => (subscribableThing, prependedValue) => wrapSubscribeFunction((observer) => {
    observer.next(prependedValue);
    return subscribableThing(observer);
});
//# sourceMappingURL=prepend-subscribable-thing.js.map